var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"qa-detail-modal"},[_c('md-dialog',{ref:"qaDetailModal",attrs:{"md-close-to":"#qaDetailModal","md-open-from":"#qaDetailModal"}},[_c('md-dialog-title',[_vm._v("Question")]),_c('md-dialog-content',[_c('div',{staticClass:"detail-wrapper"},[(_vm.id)?_c('detail',{attrs:{"id":_vm.id}}):_vm._e()],1)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }